<div class="flex flex-column p-2">
  <!-- Header -->
  <div class="text-xl font-medium mb-4">จัดการการคืนเงินสนาม</div>

  <!-- Main Action Selection -->
  <div class="mb-4">
    <form [formGroup]="formGroup">
      <formly-form [model]="formData" [fields]="fields" [form]="formGroup">
      </formly-form>
    </form>
  </div>

  <!-- Action Buttons -->
  <div class="flex justify-content-end mt-4">
    <p-button
      icon="pi pi-times"
      label="ยกเลิก"
      styleClass="p-button-outlined p-button-secondary mr-2"
      (onClick)="onCancel()">
    </p-button>
    <p-button
      icon="pi pi-check"
      label="ยืนยันการดำเนินการ"
      [disabled]="!formGroup.valid"
      (onClick)="onConfirm()">
    </p-button>
  </div>
</div>
